import { Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import {
  Button,
  CalendarIcon,
  CloseIcon,
  Dropdown,
  DropdownContent,
  DropdownItem,
} from 'ui-components';

import { usePostedBy } from '../../hooks/usePostedBy';
import { useAddContentStore } from '../useAddContentStore';
import { timeframes } from './constants';

export const Posted = () => {
  const { setIsCustomModalOpen } = useAddContentStore();
  const { selectedTime, handleSelectPostedBy, handleReset } = usePostedBy();

  const handleOpenCustomModal = useCallback(() => {
    setIsCustomModalOpen(true);
  }, [setIsCustomModalOpen]);

  return (
    <Dropdown>
      {({ buttonRef, getReferenceProps }) => (
        <>
          <Button
            variant="tertiary"
            ref={buttonRef}
            leftIcon={<CalendarIcon boxSize={4} />}
            rightIcon={
              selectedTime?.value !== 0 ? (
                <CloseIcon onClick={handleReset} boxSize={4} />
              ) : undefined
            }
            size="md"
            {...getReferenceProps()}
          >
            <Text color="primary.400" fontWeight={400}>
              Posted:
            </Text>
            <Text color="primary.700">{selectedTime?.friendlyValue}</Text>
          </Button>
          <DropdownContent>
            {timeframes.map((t) => (
              <DropdownItem
                key={t.value}
                onClick={() => handleSelectPostedBy(t.value)}
              >
                {t.friendlyValue}
              </DropdownItem>
            ))}
            <DropdownItem onClick={handleOpenCustomModal}>Custom</DropdownItem>
          </DropdownContent>
        </>
      )}
    </Dropdown>
  );
};
